var map = {
	"./avatar.png": 119,
	"./behance.jpg": 120,
	"./cl.gif": 26,
	"./code.png": 121,
	"./diamond.png": 122,
	"./email.png": 27,
	"./fav.png": 28,
	"./ha.gif": 29,
	"./heart.png": 30,
	"./java.png": 31,
	"./linkedin.jpg": 32,
	"./linkedin.png": 33,
	"./motive.png": 123,
	"./quote1.png": 23,
	"./rocket_launch.png": 124,
	"./rocket_launch_.png": 125,
	"./s1.png": 126,
	"./source.gif": 127,
	"./testimonial-avatar.png": 128,
	"./testimonial.jpg": 78,
	"./work/1.png": 34,
	"./work/2.png": 35,
	"./work/22.png": 36,
	"./work/23.png": 37,
	"./work/3.png": 38,
	"./work/4.png": 39,
	"./work/55769960_116907276143171_3978053186920382464_n.jpg": 40,
	"./work/57465186_127719958395236_2192767300677926912_o.jpg": 41,
	"./work/React-App11.png": 42,
	"./work/a1.png": 43,
	"./work/a2.png": 44,
	"./work/ai.jpg": 45,
	"./work/c1.png": 46,
	"./work/c2.png": 47,
	"./work/devops.jpg": 48,
	"./work/gd.jpg": 49,
	"./work/logo1.png": 50,
	"./work/mag.png": 51,
	"./work/no-image.png": 52,
	"./work/pointing.jpg": 53,
	"./work/s1.png": 11,
	"./work/s2.png": 12,
	"./work/s3.png": 13,
	"./work/taxi.png": 54,
	"./work/todo.png": 55,
	"./work/ui.png": 56,
	"./work/ui1.png": 57,
	"./work/zd.png": 58
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 118;


//////////////////
// WEBPACK FOOTER
// ./src/static/img ^\.\/.*$
// module id = 118
// module chunks = 0